<template>
  <div>
    <el-upload v-if="type == 'drag'" class="upload-demo" ref="upload" drag action="/" :limit="limit" multiple
      :on-preview="handlePreview" :on-remove="handleRemove" :file-list="fileList" :http-request="addFileToFormData"
      :before-remove="beforeRemove" :on-exceed="onexceed" :before-upload="beforeDragUpload" :accept="accept"
      list-type="text">
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">
        将文件拖到此处，或<em>点击上传</em>
        <p v-if="notice != ''" style="margin-top: -20px">{{ notice }}</p>
      </div>
    </el-upload>
    <el-upload v-if="type == 'noDrag'" class="upload-demo" ref="upload" action="/" multiple :limit="limit"
      :on-preview="handlePreview" :on-remove="handleRemove" :file-list="fileList" :http-request="addFileToFormData"
      :before-remove="beforeRemove" :on-exceed="onexceed" list-type="text">
      <el-button slot="trigger" size="small" type="primary">添加</el-button>
    </el-upload>
    <el-upload v-if="type == 'preview'" ref="upload" action="/" multiple list-type="picture-card" :limit="limit"
      :on-preview="handlePreview" :file-list="fileList" :http-request="addFileToFormData" :before-remove="beforeRemove"
      :on-remove="handleRemove" :on-progress="addFileToFormData" :before-upload="beforeAvatarUpload"
      :on-exceed="onexceed">
      <i class="el-icon-plus"></i>
    </el-upload>
    <el-upload v-if="type == 'single'" :multiple="false" list-type="picture-card" ref="upload" action="#"
      :show-file-list="false" :before-upload="beforeAvatarUpload">
      <el-image v-if="imageUrl != ''" :src="imageUrl" class="avatar" style="width: 100%; height: 100%" fit="contain">
      </el-image>
      <i v-else class="el-icon-plus"></i>
      <button ref="cusUpLoad" style="display: none">点击上传</button>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      fileList: [],
      deleteIds: [],
      addFiles: [],
      imageUrl: "",
      isSuccess: true,
      dialogImageUrl: "",
      dialogVisible: false,
      isRemove: false, //通过实践动作删除，不需要提示
    };
  },
  props: {
    notice: {
      type: String,
      default: "",
    },
    accept: {
      type: String,
      default: "",
    },
    //上传成功后是否清空
    isEmpty: {
      type: Boolean,
      default: false,
    },
    //是否必选
    required: {
      type: Boolean,
      default: true,
    },
    //附件最大数(单文件无效)
    limit: {
      type: Number,
      default: 20,
    },
    //默认文件
    files: {
      type: Array,
      default: () => [],
    },
    //默认图片(多文件无效)
    defImage: {
      type: String,
      default: "",
    },
    //附件Code
    enclosureCode: {
      type: String,
      default: "",
    },
    // drag 拖拽  noDrag   preview 可视  single  单选
    type: {
      type: String,
      default: "single",
    },
    //上传附件大小限制（单位M）
    size: {
      type: Number,
      default: 2,
    },
  },
  methods: {
    //删除附件之前
    beforeRemove(file, fileList) {
      return true;
      // if(this.isRemove) return true;
      // return this.$confirm(`确定删除 ${file.name}？`, "提示", {
      //   type: "warning",
      // });
    },

    //文件列表移除文件时的钩子
    handleRemove(file, fileList) {
      if (file.status == "success") {
        this.deleteIds.push(file.EnclosureId);
      }
      if (file.status == "ready") {
        this.addFiles.splice(this.addFiles.indexOf(file.file), 1);
      }
    },
    //点击文件列表中已上传的文件时的钩子
    handlePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //覆盖默认的上传行为，可以自定义上传的实现
    addFileToFormData(file, fileList) {
      this.addFiles.push(file.file);
    },
    onexceed(files, fileList) {
      this.$message.error("上传数量超过限制");
    },
    onprogress() { },
    beforeDragUpload(file) {
      if (this.size > 0) {
        const isLt = file.size / 1024 / 1024 <= this.size;
        if (!isLt) {
          this.$message.error("上传头像图片大小不能超过 " + this.size + "MB!");
        }
        return isLt;
      }
    },
    //上传文件之前的钩子，参数为上传的文件，若返回 false 或者返回 Promise 且被 reject，则停止上传。
    beforeAvatarUpload(file) {
      this.isRemove = false;
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < this.size;
      const isPNG = file.type === "image/png";
      if (!isJPG && !isPNG) {
        this.$message.error("上传头像图片只能是 JPG、png 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 " + this.size + "MB!");
      }
      this.isSuccess = (isJPG || isPNG) && isLt2M;
      if (this.isSuccess && this.type == "single") {
        this.addFiles = [];
        this.imageUrl = URL.createObjectURL(file);
        this.addFiles.push(file);
      }
      if (!this.isSuccess) {
        this.isRemove = true;
      }
      return this.isSuccess;
    },
    //通过code获取文件
    getfile(code) {
      this.fileList = [];
      if (this.type == "single") {
        //单选
        this.$com.getFileList(this.$axios, code, (result) => {
          if (result.length > 0) {
            let n = result[result.length - 1];
            let item = {
              name: n.enclosurename + "." + n.enclosuretype,
              EnclosureId: n.enclosureid,
              url: this.Glod.UrlPrefix + n.enclosureurl,
            };
            this.imageUrl = item.url;
            this.fileList.push(item);
          }
        });
      } else {
        this.$com.getFileList(this.$axios, code, (result) => {
          result.forEach((n) => {
            let item = {
              name: n.enclosurename + "." + n.enclosuretype,
              EnclosureId: n.enclosureid,
              url: this.Glod.UrlPrefix + n.enclosureurl,
            };
            this.fileList.push(item);
          });
        });
      }
    },
    //异步提交
    async submitUpload() {
      if (!this.isSuccess) {
        return;
      }
      if (this.addFiles.length == 0 && this.deleteIds.length == 0) {
        if (this.required && this.fileList.length == 0) {
          reject(new Error("附件不能为空").message);
          return;
        } else {
          this.$emit("fileUpload", this.enclosureCode);
        }
      }
      if (this.required && this.addFiles.length == 0) {
        let l = this.fileList.length;
        if (l <= this.deleteIds.length) {
          reject(new Error("附件不能为空").message);
          return;
        }
      }
      let fileData = new FormData();
      this.addFiles.forEach((n) => {
        fileData.append("file", n);
      });
      fileData.append("keycode", this.enclosureCode);
      fileData.append("deleteIds", this.deleteIds);
      await this.$axios
        .post("Comenclosure/InsertComEnclosures", fileData)
        .then((res) => {
          if (res.data.statusCode == 200) {
            if (this.isEmpty) {
              this.enclosureCode = "";
              this.deleteIds = [];
              this.imageUrl = "";
              this.addFiles = [];
            }
            this.$emit("fileUpload", res.data.result);
          } else{
            this.$message.error({
              message: res.data.msg,
              showClose: true,
              duration: 0,
            });
          }

        })
        .catch((error) => {
          console.log(error);
        });
    },
    //同步提交
    awaitSubmitUpload() {
      let than = this;
      return new Promise((resolve, reject) => {
        let url = "Comenclosure/InsertComEnclosures";
        if (!than.isSuccess) {
          reject(new Error("附件上传失败").message);
          return;
        }
        if (than.addFiles.length == 0 && than.deleteIds.length == 0) {
          if (than.required && than.fileList.length == 0) {
            reject(new Error("附件不能为空").message);
            return;
          } else {
            resolve(than.enclosureCode);
            return;
          }
        }
        if (this.required && this.addFiles.length == 0) {
          let l = this.fileList.length;
          if (l <= this.deleteIds.length) {
            reject(new Error("附件不能为空").message);
            return;
          }
        }
        let fileData = new FormData();
        this.addFiles.forEach((n) => {
          fileData.append("files", n);
        });
        // fileData.append("file", fileList);
        fileData.append("keycode", this.enclosureCode);
        fileData.append("deleteIds", this.deleteIds);
        fileData.append("filesKey", this.enclosureCode);
        this.$axios
          .post(url, fileData)
          .then((res) => {
            if (res.data.statusCode == 200) {
              this.deleteIds = [];
              this.addFiles = [];
              if (this.isEmpty) {
                this.enclosureCode = "";
                this.imageUrl = "";
              }
              resolve(res.data.result);
            } else reject(new Error("附件上传失败").message);
          })
          .catch((error) => {
            console.log(error);
            reject(new Error("附件上传失败").message);

          });
      });
    },
    //单文件上传
    upLoad() {
      this.$refs["cusUpLoad"].click();
    },
  },
  watch: {
    enclosureCode: function (val, old) {
      if (val != "") this.getfile(val);
    }
  },
  created() {
    this.imageUrl = this.defImage;
    if (this.enclosureCode == "") this.fileList = [];
    else if (this.enclosureCode == undefined) this.fileList = [];
    else if (this.files && this.files.length > 0) {
      this.files.forEach((n) => {
        let item = {
          name: n.enclosurename + "." + n.enclosuretype,
          EnclosureId: n.enclosureid,
          url: this.Glod.UrlPrefix + n.enclosureurl,
        };
        this.fileList.push(item);
      });
    } else {
      this.getfile(this.enclosureCode);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Upload/upLoadFile.vue